import React from 'react';
import { useTranslation } from 'react-i18next';
import { Row, Button } from 'antd';

import './Welcome.css'



export default function Welcome({carrierConfig}) {
  const { t } = useTranslation('carrierSignup');

  console.log({carrierConfig})

	return (
		<div className='welcomeContainer'>
      <Row>
			  <h1>{carrierConfig?.locizeOverride?.card?.title || t("register.card.title")}</h1>
      </Row>
      <Row>
        <img className='logoImg' src={carrierConfig.carrier.logoSrc} alt="Logo" height={131} />
      </Row>
      <Row>
        <ul className='welcomeItems'>
          <li>{carrierConfig?.locizeOverride?.card?.intromessage || t("register.card.intromessage")}</li>
          <li>{carrierConfig?.locizeOverride?.card?.accountexplanation || t("register.card.accountexplanation")}</li>
          <li>{carrierConfig?.locizeOverride?.card?.questions || t("register.card.questions")}</li>
          <li>{carrierConfig?.locizeOverride?.card?.bookingtime || t("register.card.bookingtime")}</li>
        </ul>
      </Row>
      <Row>
        <div className="buttonContainer">
          <Button id="pdfInstructions" type="text" icon={<img src="pdfIcon.svg" alt="PDF icon" />} onClick={() => window.open(carrierConfig.guide, "_blank")} size='large'>
            &nbsp;&nbsp;&nbsp;{t("register.form.messages.infoclick")}
          </Button>
        </div>
      </Row>
		</div>
	);
}
